import { render } from "./list_set.vue?vue&type=template&id=33c95f81&scoped=true"
import script from "./list_set.vue?vue&type=script&lang=js"
export * from "./list_set.vue?vue&type=script&lang=js"

import "./list_set.vue?vue&type=style&index=0&id=33c95f81&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c95f81"]])

export default __exports__